import {
  Component,
  Input,
  NgModule,
  OnChanges,
  SimpleChanges,
  Inject
} from '@angular/core';
import { Router } from '@angular/router';

import {
  ContractStatus,
  DetailLotEnum,
  LotStatus
} from './../../../models/generic';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { IHeaderItem, ILot, IContractLot } from 'src/app/models/generic';
import {
  DialogTypeEnum,
  IDialogConfirm,
  DialogContractTypeEnum,
  IManagementContractsModalData
} from 'src/app/models/dialog';
import { StatusBadgeTone } from 'src/app/shared/components/status-badge/status-badge.component';
import { contractStatusTone as resolveContractStatusTone } from 'src/app/shared/utils/status-badge.util';
import {
  InvoiceContractsHeaderItems,
  TransferContractsHeaderItems
} from './../../../shared/utils/base';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ClipboardService } from 'ngx-clipboard';
import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
@Component({
  selector: 'app-detalhes-lotes-list',
  templateUrl: './detalhes-lotes-list.component.html',
  styleUrls: ['./detalhes-lotes-list.component.scss']
})
export class DetalhesLotesListComponent implements OnChanges {
  @Input() lot!: ILot;
  @Input() typeDetail!: DetailLotEnum;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';

  DetailLotEnum = DetailLotEnum;
  unregisteredContractsList: string[] = [];
  reversedContract: boolean = true;
  headerItems: IHeaderItem[] = [];

  constructor(
    private _dialogService: ApiDialogService,
    private _snackbarService: SnackbarService,
    private _clipboardApi: ClipboardService,
    private _datePipe: DatePipe,
    private _currencyPipe: CurrencyPipe,
    private _titleCasePipe: TitleCasePipe,
    private _router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['typeDetail']) {
      this.headerItems =
        this.typeDetail === DetailLotEnum.Invoicing
          ? InvoiceContractsHeaderItems
          : TransferContractsHeaderItems;
    }
  }

  handlerManageContracts(): void {
    if (this.lot.BatchStatus == 'Em Andamento') {
      this.openDialogContracts();
    } else {
      if (this.isEditable) {
        this.openManageContracts();
      } else {
        this.openInfoMessage();
      }
    }
  }

  get isEditable(): boolean {
    let lotStatus: string =
      this.lot?.BatchStatus?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') ??
      this.lot?.StatusOfOnlending?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') ??
      '';

    this.unregisteredContractsList = this.unregisteredContracts;

    return (
      lotStatus !== LotStatus.Aprovacao &&
      this.unregisteredContractsList.length === 0
    );
  }

  get isAndamento(): boolean {
    let lotStatus: string =
      this.lot?.BatchStatus?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') ??
      this.lot?.StatusOfOnlending?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') ??
      '';

    return (
      this.typeDetail === DetailLotEnum.Invoicing &&
      lotStatus === LotStatus.Andamento
    );
  }

  get unregisteredContracts(): string[] {
    if (this.lot?.Contracts?.length && this.lot?.Contracts?.length > 0) {
      let unregisteredContracts: string[] = this.lot.Contracts.filter(
        (contract) =>
          contract.Status.toLowerCase().trim() === ContractStatus.Aprovacao ||
          contract.Status.toLowerCase().trim() ===
            ContractStatus.AprovacaoContrato
      ).map((contract) => contract.Number);

      return unregisteredContracts;
    } else {
      return [];
    }
  }

  contractStatusTone(contract: IContractLot): StatusBadgeTone {
    return resolveContractStatusTone(contract.StatusOverride || contract.Status, {
      toReverse: contract.ToReverse === true
    });
  }

  contractIsCancelled(contract: IContractLot): boolean {
    return (contract.StatusOverride || contract.Status || '').toLowerCase().includes('cancelad');
  }

  openContractDetails(contract: IContractLot): void {
    this._router.navigate(
      ['/contratos', contract.Number, contract.QueryNumber, contract.FinancialInstitution, 'detalhes', 'visualizar'],
      { queryParams: { returnUrl: this._router.url } }
    );
  }

  exportToClipboard(): void {
    let content: string =
      ' \tNº Contrato\tBanco\tValor Financiamento\tValor Comissão\tTipo de Operação\tCliente\tCPF/CNPJ Cliente\tComissão\tDt. Produção\tStatus\r\n';

    if (this.lot.Contracts != null && this.lot.Contracts.length > 0) {
      this.lot.Contracts.forEach((contract: IContractLot) => {
        let status = contract.Active! ? 'Ativo' : 'Cancelado';
        content += `${status}\t${
          contract.Number
        }\t${this._titleCasePipe.transform(
          contract.FinancialInstitution
        )}\t${this._currencyPipe.transform(
          contract.Amount,
          'BRL'
        )}\t${this._currencyPipe.transform(contract.InvoiceAmount, 'BRL')}\t${
          contract.OperationType
        }\t${contract.Client}\t${contract.ClientDocument}\t${
          contract.BeneficiaryFee
        }%\t${this._datePipe.transform(
          contract.ProductionDate,
          'dd/MM/yyyy'
        )}\t${contract.Status}\r\n`;
      });
    }

    navigator.clipboard.writeText(content).then(() => {
      this._snackbarService.openSnackBar(
        'Copiado para área de transferência!',
        'success'
      );
    });
  }

  openInfoMessage(): void {
    let text: string = this.formatTextManageContracts();

    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Confirmation,
      appearance: 'modern',
      template: {
        boldTitle: 'Não é possível editar o lote nesse momento',
        title: text,
        confirm: 'Voltar'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {});
  }

  formatTextManageContracts(): string {
    let contractNumbers: string = this.unregisteredContractsList.join(', ');
    let text: string = '';

    if (this.unregisteredContractsList.length > 1) {
      text = `Um novo lote será gerado após aprovação dos contratos ${contractNumbers}`;
    } else {
      text = `Um novo lote será gerado após aprovação do contrato ${contractNumbers}, `;
    }

    return text;
  }

  openManageContracts(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Gerenciar contratos',
        title: 'Após a confirmação do gerenciamento de contratos, será gerado um novo lote!',
        confirm: 'Avançar',
        dismiss: 'Voltar'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.openDialogContracts();
      }
    });
  }

  openDialogContracts(): void {
    if (this.typeDetail === DetailLotEnum.Invoicing) {
      if (
        !this.lot.Bank &&
        this.lot?.Contracts?.length &&
        this.lot?.Contracts?.length > 0
      ) {
        this.lot.Bank = this.lot.Contracts[0].FinancialInstitution;
      }
    }
    if (this.typeDetail === DetailLotEnum.Transfer) {
      if (
        !this.lot.Partner &&
        this.lot?.Contracts?.length &&
        this.lot?.Contracts?.length > 0
      ) {
        this.lot.Bank = this.lot.Contracts[0].FinancialInstitution;
      }
    }

    const dataDialog: IManagementContractsModalData = {
      type: DialogContractTypeEnum.EditContract,
      lot: this.lot,
      template: {
        title: 'Editar contratos',
        description: 'Adicione contratos ao novo lote',
        textConfirmButton: 'Próximo',
        typeLot: this.typeDetail
      }
    };

    this._dialogService.openDialogContracts(dataDialog).then((response) => {});
  }
}
